module.exports = __webpack_public_path__ + "static/media/ту.eb693741.mp3";